import { Slide01Title } from './Slide01Title'
import { Slide02ScopeAssumptions } from './Slide02ScopeAssumptions'
import { Slide03CostEstimate } from './Slide03CostEstimate'
import { Slide04Engagement } from './Slide04Engagement'
import { SlideTeaserCampaign } from './SlideTeaserCampaign'
import { SlidePerformanceInsights } from './SlidePerformanceInsights'

export const slides = [
  Slide01Title,
  Slide02ScopeAssumptions,
  Slide04Engagement,
  SlideTeaserCampaign,
  SlidePerformanceInsights,
  Slide03CostEstimate,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'Title' },
  { section: '1', title: 'Why Snaks · Scope & Assumptions' },
  { section: '2', title: 'Evergreen Webinar Snak' },
  { section: '3', title: 'Teaser-to-Insight Flow' },
  { section: '4', title: '3-Month Performance Readout' },
  { section: '5', title: 'Key Cost Elements & Estimate' },
]
